import { faWarning } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useBlocker } from 'react-router';
import { TrackingEventData } from '../../../hooks/useTracking';
import { ORANGE500 } from '../../../theme';
import { EventLabels } from '../../../utils/trackingEvents';
import { ConfirmationModal } from '../ConfirmationModal';

const NavigationBlockerModal: React.FC<{
  title?: string;
  description: string;
  when: boolean;
  trackingData?: TrackingEventData;
}> = ({ when, title, description, trackingData }) => {
  const blocker = useBlocker(when);
  const [showConfirmation, setShowConfirmation] = useState(false);

  useEffect(() => {
    if (!when) {
      blocker.proceed?.();
      setShowConfirmation(false);
      return;
    }
    if (blocker.state === 'blocked') {
      setShowConfirmation(true);
    }
  }, [blocker.state, when, blocker.proceed]);

  return (
    <ConfirmationModal
      isOpen={showConfirmation}
      title={title ?? 'Discard changes?'}
      titleIcon={
        <FontAwesomeIcon icon={faWarning} color={ORANGE500} fontSize={20} />
      }
      description={description}
      confirmLabel="Discard Changes"
      cancelLabel="Continue Editing"
      confirmButtonEventLabelOverride={EventLabels.DiscardChanges}
      cancelButtonEventDataLabelOverride={EventLabels.Continue}
      onConfirm={() => {
        setShowConfirmation(false);
        blocker?.proceed?.();
      }}
      onClose={() => {
        setShowConfirmation(false);
        blocker?.reset?.();
      }}
      trackingData={trackingData}
    />
  );
};

export default NavigationBlockerModal;
